import { ReactNode } from 'react';
import { Button, Dialog, Modal, Text } from '@oliasoft-open-source/react-ui-library';

type MoveFileDialogProps = {
  heading: string;
  message: ReactNode;
  actions: { label: string; colored?: boolean | string; disabled?: boolean; onClick: () => void }[];
  onClose?: () => void;
};

export const MoveFileDialog = ({
  heading, message, actions, onClose,
}: MoveFileDialogProps) => {
  return (
    <Modal visible centered onEscape={onClose}>
      <Dialog
        dialog={{
          heading,
          width: '480px',
          content: typeof message === 'string' ? <Text>{message}</Text> : message,
          footer: (
            <>
              {actions.map((action) => (
                <Button key={action.label} colored={action.colored} disabled={action.disabled} label={action.label} onClick={action.onClick} />
              ))}
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};
